function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Text, TextInput, CheckBox, RadioButtonGroup, MaskedInput, Box } from 'grommet';
import Select from 'granite-admin/core/components/Select';
import CommonAPI from 'granite-admin/common/gateways/common-api';
import MultiSelect from 'granite-admin/core/components/MultiSelect';
import Loader from 'granite-admin/core/components/Loader';
const ConfigField = ({
  name,
  setFieldValue,
  value,
  fieldName,
  entityName,
  disableSort,
  submenuOverlay,
  onChange,
  overrideType,
  configData,
  eventEmitter,
  configType,
  disableField,
  ...restProps
}) => {
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetch = async () => {
    try {
      const field = await CommonAPI.getConfigByName(name, {
        entity_name: entityName
      }, configType);
      if (!disableSort && Array.isArray(field.options)) field.options.sort();
      field.itemType = field.type;
      delete field.type;
      updateConfig(field);
      setItem(field);
      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setLoading(false);
      setError(error.message);
    }
  };
  useEffect(() => {
    let savedConfig = {
      ...configData
    };
    if (savedConfig && savedConfig.options && Array.isArray(savedConfig.options)) {
      setItem(savedConfig);
      setLoading(false);
    } else fetch();
  }, [configData]);
  const updateConfig = data => {
    let updatedConfig = {
      ...configData
    };
    updatedConfig = {
      ...updatedConfig,
      ...data,
      name: updatedConfig.name
    };
    delete updatedConfig.value;
    if (eventEmitter) eventEmitter.emit('UPDATE_FILTER_DATA', {
      name: updatedConfig.name,
      payload: updatedConfig
    });
  };
  const handleOnChange = value => {
    if (setFieldValue) setFieldValue(fieldName ? fieldName : item.name, value);
    if (onChange) onChange(value);
  };
  const checkForSelectType = type => {
    return type === 'textselect' || type === 'multitextselect' ? type : false;
  };
  const itemType = useMemo(() => {
    let defaultType = item.itemType;
    let selectedType = checkForSelectType(defaultType);
    let overriddenType = checkForSelectType(overrideType);
    return selectedType && overriddenType && selectedType !== overriddenType ? overriddenType : defaultType;
  }, [item, overrideType]);
  if (loading) {
    return /*#__PURE__*/React.createElement(Box, {
      flex: true,
      align: "center",
      justify: "end",
      direction: "row",
      pad: "small",
      margin: "small"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "10px"
    }));
  } else if (error) {
    return /*#__PURE__*/React.createElement(Text, {
      color: "status-error"
    }, "An error occurred.");
  } else if (itemType === 'textselect') {
    const {
      value: initialValues,
      ...rest
    } = item;
    return /*#__PURE__*/React.createElement(Select, _extends({
      name: item.name,
      value: value,
      options: item.options,
      onChange: ({
        value
      }) => handleOnChange(value),
      menuPortalTarget: submenuOverlay,
      closeMenuOnSelect: true,
      disabled: disableField
    }, rest, restProps));
  } else if (itemType === 'textchoice') {
    const {
      value: initialValues,
      ...rest
    } = item;
    return /*#__PURE__*/React.createElement(RadioButtonGroup, _extends({
      name: item.name,
      options: item.options,
      value: value ? value : initialValues,
      onChange: evt => handleOnChange(evt.target.value),
      placeholder: item.label,
      disabled: item.disabled || disableField
    }, rest));
  } else if (itemType === 'text') {
    return /*#__PURE__*/React.createElement(TextInput, {
      type: "text",
      name: item.name,
      disabled: item.disabled || disableField,
      onChange: e => setFieldValue(item.name, e.target.value),
      value: value,
      placeholder: item.label
    });
  } else if (itemType === 'integer') {
    return /*#__PURE__*/React.createElement(MaskedInput, {
      name: item.name,
      disabled: item.disabled || disableField,
      mask: [{
        regexp: /^[0-9]{1,}$/,
        placeholder: 'enter number'
      }],
      value: value,
      onChange: e => setFieldValue(item.name, e.target.value)
    });
  } else if (itemType === 'multitextselect') {
    let options = item.options.map(i => {
      return configData?.config_master_light === false ? {
        pk: i.pk,
        label: i.name
      } : {
        pk: i,
        label: i
      };
    });
    return /*#__PURE__*/React.createElement(MultiSelect, _extends({
      name: item.name,
      options: options,
      labelKey: "label",
      defaultSelectedOptions: options.filter(option => value?.includes(option.pk)),
      onChange: val => handleOnChange(val.map(i => i.pk)),
      disabled: item.disabled || disableField,
      menuPortalTarget: submenuOverlay
    }, restProps));
  } else if (itemType === 'boolean') {
    return /*#__PURE__*/React.createElement(CheckBox, {
      name: item.name,
      label: item.label,
      disabled: item.disabled || disableField,
      toggle: true,
      reverse: true,
      onChange: e => handleOnChange(`${e.target.checked ? item.options[0] : item.options[1]}`),
      checked: value === `${item.options[0]}`
    });
  } else return null;
};
ConfigField.defaultProps = {
  disableSort: false,
  configType: 'OPTIONS',
  disableField: false
};
ConfigField.propTypes = {
  disableSort: PropTypes.bool,
  name: PropTypes.string,
  setFieldValue: PropTypes.func,
  value: PropTypes.any,
  fieldName: PropTypes.string,
  entityName: PropTypes.string,
  disableField: PropTypes.bool,
  restProps: PropTypes.object
};
ConfigField.displayName = 'ConfigField';
export default ConfigField;